import React from "react";

const DeviceContext = React.createContext({
  device: "",
  loading: true,
  needSizeAdjust: true,
});

export default DeviceContext;
